module.exports = "/hwa/_next/static/images/skip-bag-f564b7c4e0440dbd545313382cffef2a.png";